// src/utils/uploadLimits.js

/**
 * Format bytes to human-readable size
 */
export function formatFileSize(bytes) {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
}

/**
 * Get upload limit in bytes from GB
 */
export function gbToBytes(gb) {
  return gb * 1024 * 1024 * 1024;
}

/**
 * Check if file exceeds limit
 */
export function isFileTooLarge(fileSizeBytes, maxGb) {
  return fileSizeBytes > gbToBytes(maxGb);
}

/**
 * Get upload limit text
 */
export function getUploadLimitText(maxGb) {
  return `Max file size: ${maxGb} GB`;
}
